import { useEffect, useState } from "react";
import { modalActions } from "../../../context/actions/modalActions";
import useStore from "../../../context/useStore";
import dataService from "../../../helpers/dataService";
import { Link } from "react-router-dom";
import useEspaceActif from "../../../hooks/useEspaceActif/useEspaceActif";
import {
  filtrerQuittancesParEspace,
  grouperQuittancesParClient,
} from "./quittancesParClient";

const useContractRenewAll = () => {
  const [state, dispatch] = useStore();
  const modal_actions = modalActions(state, dispatch);
  const { espace } = useEspaceActif();
  const [isLoading, setIsLoading] = useState(false);
  const [quittances, setQuittances] = useState([]);
  const [selectedClientToPay, setSelectedClientToPay] = useState(null);

  const getAllRenewableContracts = async () => {
    setIsLoading(true);
    dataService.get(
      `receipts/mines/to-pay`,
      setQuittances,
      (err) => {},
      () => setIsLoading(false)
    );
  };

  // Les quittances de l'espace inactif restent chargées (elles réapparaissent à
  // la bascule) mais ne sont ni affichées ni proposées au paiement (PER-2211).
  const quittancesAffichees = filtrerQuittancesParEspace(quittances, espace);

  const onSelectClientToPay = (client, selectedQuittances) => {
    setSelectedClientToPay({ ...client, quittances: selectedQuittances });
  };

  const onDeselectClientToPay = () => {
    setSelectedClientToPay(null);
  };

  const onPaidQuittances = (quittancesIds, modePayment) => {
    setQuittances([
      ...quittances.map((q) => {
        return quittancesIds.includes(q.id) ? { ...q, isPaid: true } : q;
      }),
    ]);
    onDeselectClientToPay();
    openSuccessPaymentModal(modePayment);
  };

  const openSuccessPaymentModal = (modePayment) => {
    modal_actions.updateModal({
      isOpen: true,
      showCloseButtonSeconds: 5,
      content: (
        <div className="font-weight-bold text-center text-info mb-4">
          {modePayment === "CB" && (
            <div>Votre paiement par CB a été accepté.</div>
          )}
          {modePayment === "SEPA" && (
            <div className="mb-2">
              Votre prélèvement SEPA <br />
              est en cours de traitement
              <br /> auprès de votre banque.
            </div>
          )}
          <i className="animated zoomIn faster fa fa-check-circle fa-4x my-3"></i>
          <br />
          {modePayment === "CB" && (
            <p className="font-weight-normal text-dark text-sm">
              Retrouvez votre facture sur la page{" "}
              <Link
                onClick={() =>
                  modal_actions.updateModal({ isOpen: false, content: null })
                }
                to="/mes-factures"
              >
                Mes factures
              </Link>
              .
            </p>
          )}
          {modePayment === "SEPA" && (
            <p className="font-weight-normal text-dark text-sm">
              Votre facture sera disponible dès la réception des fonds par
              Perceval. Habituellement 10 jours.
            </p>
          )}
        </div>
      ),
      containerStyle: {
        maxWidth: 450,
      },
    });
  };

  return {
    isLoading,
    selectedClientToPay,
    quittances: quittancesAffichees,
    clients: grouperQuittancesParClient(quittancesAffichees),
    getAllRenewableContracts,
    onSelectClientToPay,
    onDeselectClientToPay,
    onPaidQuittances,
  };
};

export default useContractRenewAll;

/*
quittance array example : 

[
    {
        "id": "6412ff6b7ed73e001d069254",
        "modulrId": "14373",
        "restantDu": 463,
        "restantDu": 0,
        "debutPeriode": "2022-12-31T20:00:00.000Z",
        "dateLimite": "2023-01-15T20:00:00.000Z",
        "createdAt": "2023-09-08T10:06:42.000Z",
        "updatedAt": "2024-05-08T02:10:01.365Z",
        "contrat": {
            "id": "5da444de0fca280017176cd0",
            "numero": "504901-373755",
            "titre": "PJ Professionnelle GoZen +",
            "objet": "Agences de Communication (publicité, photo, salons, congrès, Services d'information…)",
            "compagnie": "SFPJ GROUPAMA PJ",
            "nomProduit": "504901+"
        },
        "client": {
            "id": "5da444de0fca280017176ccf",
            "nomSociete": "10POSITIF"
        }
    },
    {
        "id": "6218b0cf511edd001d9ad7a5",
        "modulrId": "10001",
        "restantDu": 463,
        "restantDu": 0,
        "debutPeriode": "2021-12-31T20:00:00.000Z",
        "dateLimite": "2022-03-15T20:00:00.000Z",
        "createdAt": "2022-02-25T09:47:38.000Z",
        "updatedAt": "2024-05-08T02:10:01.365Z",
        "contrat": {
            "id": "5da444de0fca280017176cd0",
            "numero": "504901-373755",
            "titre": "PJ Professionnelle GoZen +",
            "objet": "Agences de Communication (publicité, photo, salons, congrès, Services d'information…)",
            "compagnie": "SFPJ GROUPAMA PJ",
            "nomProduit": "504901+"
        },
        "client": {
            "id": "5da444de0fca280017176ccf",
            "nomSociete": "10POSITIF"
        }
    },
    {
        "id": "605766165fdf620015fefe2e",
        "modulrId": "6517",
        "restantDu": 463,
        "restantDu": 0,
        "debutPeriode": "2020-12-31T20:00:00.000Z",
        "dateLimite": "2021-03-30T20:00:00.000Z",
        "createdAt": "2021-03-21T13:04:05.000Z",
        "updatedAt": "2024-05-08T02:10:01.365Z",
        "contrat": {
            "id": "5da444de0fca280017176cd0",
            "numero": "504901-373755",
            "titre": "PJ Professionnelle GoZen +",
            "objet": "Agences de Communication (publicité, photo, salons, congrès, Services d'information…)",
            "compagnie": "SFPJ GROUPAMA PJ",
            "nomProduit": "504901+"
        },
        "client": {
            "id": "5da444de0fca280017176ccf",
            "nomSociete": "10POSITIF"
        }
    }
]

*/
